import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';  // Ensure Bootstrap JS is included
import './SliderPage.css';

import firstSlider from '../assets/img/slider_img/slider_one.png';
import secondSlider from '../assets/img/slider_img/slider_two.png';
import thirdSlider from '../assets/img/slider_img/touch.jpg';
import fourthSlider from '../assets/img/slider_img/no_pain.jpg';
import fifthSlider from '../assets/img/slider_img/haz.jpg';
import sixthSlider from '../assets/img/slider_img/prot.jpg';
import seventhSlider from '../assets/img/slider_img/stage.jpg';
import eightSlider from '../assets/img/slider_img/preg.jpg';
import ninethSlider from '../assets/img/slider_img/implant.jpg';
import TenthSlider from '../assets/img/slider_img/know.jpg';

const slides = [
  {
    img: firstSlider,
    heading: 'Early detection saves lives',
    text: 'Get screened regularly With safe modality',
  },
  {
    img: secondSlider,
    heading: 'Breast Infrared Imager',
    text: '',
  },
  {
    img: thirdSlider,
    heading: 'No Touch',
    text: '',
  },
  {
    img: fourthSlider,
    heading: 'No Pain',
    text: '',
  },
  {
    img: fifthSlider,
    heading: 'No Hazardous X-Ray Radiations',
    text: '',
  },
  {
    img: sixthSlider,
    heading: 'No Intravenous FDG & Proteins',
    text: '',
  },
  {
    img: seventhSlider,
    heading: 'Suitable for all age groups',
    text: '',
  },
  {
    img: eightSlider,
    heading: 'Safe for Pregnant women',
    text: '',
  },
  {
    img: ninethSlider,
    heading: 'Best suited for breasts with implants',
    text: '',
  },
  {
    img: TenthSlider,
    heading: '6 Breast Views for better interpretations',
    text: '',
  },
];

const SliderPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const intervalTime = currentSlide >= 2 ? 2000 : 4000; // Faster interval from 3rd slide onwards

    // Change the interval when the slide changes
    const intervalId = setInterval(() => {
      const nextSlide = (currentSlide + 1) % slides.length;
      setCurrentSlide(nextSlide);
    }, intervalTime);

    return () => clearInterval(intervalId); // Clean up the interval when the component is unmounted
  }, [currentSlide]);

  return (
    <div id="customSlider" className="carousel slide pink-slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-item ${index === currentSlide ? 'active' : ''}`}
          >
            <div className="slider-content container">
              <div className="text-section">
                <h1 className="display-5 fw-bold">{slide.heading}</h1>
                <p className="lead">{slide.text}</p>
              </div>
              <div className="image-section d-none d-md-flex">
                <img
                  src={slide.img}
                  alt="Slide visual"
                  className="custom-image"
                />
              </div>
            </div>

            {/* Mobile Background Image */}
            <div
              className="mobile-bg d-md-none"
              style={{ backgroundImage: `url(${slide.img})` }}
            ></div>
          </div>
        ))}
      </div>

      {/* Navigation Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#customSlider"
        data-bs-slide="prev"
        onClick={() => setCurrentSlide((currentSlide + slides.length - 1) % slides.length)}
      >
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#customSlider"
        data-bs-slide="next"
        onClick={() => setCurrentSlide((currentSlide + 1) % slides.length)}
      >
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default SliderPage;
